module.exports = __webpack_public_path__ + "img/hardyHips1.5415db16.png";